import axios from "axios";

export const state = {
    pharmacy_items: [],
    item_categories: [],
    units: [],
    suppliers: [],
    drug_dispense:[],
    incomplete_dosage:[],
    stock_cart:[],
    total_cart:"",
    dispense_state:false,
    unit_state:false,
    cat_state:false,
    drugagerange_state:false,
    items_state:false,
    drugs: [],
    short_expiries: [],
    expired: [],
    reconcile: [],
    stockout: [{}],
    sale: [],
    drug_age_range: [],
    reconciliation: [],
    supplier_show_status:true,
    reconciliationdetails: [],
  
};

export const getters = {
 
    PharmacyItems: state => state.pharmacy_items.data,
    IncompleteDosage: state => state.incomplete_dosage.data,
    ItemCategories: state => state.item_categories.data,
    Units: state => state.units.data,
    StockCart: state => state.stock_cart.data,
    ShortExpiries: state => state.short_expiries.data,
    ToReconcile: state => state.reconcile.data,
    ExpiredItems: state => state.expired.data,
    DrugAgeRange: state => state.drug_age_range.data,
    TotalCart: state => state.total_cart,
    Suppliers: state => state.suppliers.data,
    DrugDispense: state => state.drug_dispense.data,
    DispenseState: state => state.dispense_state,
    UnitState: state => state.unit_state,
    CategoryState: state => state.cat_state,
    DrugageState: state => state.drugagerange_state,
    ItemsState: state => state.items_state,
    DRUGS: state => state.drugs.data,
    StockOut: state => state.stockout,
    Sale: state => state.sale.data,
    ReconciliationReport: state => state.reconciliation.data,
    ReconcileReport: state => state.reconciliationdetails.data,
};

export const mutations = {
    SET_SUPPLIER_SHOW_STATUS(state, newValue) {
        state.supplier_show_status = newValue
    },
    SET_STOCK_OUT(state, newValue) {
        state.stockout = newValue
    },
    SET_SALE(state, newValue) {
        state.sale = newValue
    },
    SET_DRUGAGE(state, newValue) {
        state.drug_age_range = newValue
    },
    
     SET_INCOMPLETE_DOSAGE(state, newValue) {
        state.incomplete_dosage = newValue
    },

    SET_PHARMACY_ITEMS(state, newValue) {
        state.pharmacy_items = newValue
    },

    SET_ITEM_CATEGORIES(state, newValue) {
        state.item_categories = newValue
    },
    SET_CATEGORY_STATE(state, newValue) {
        state.cat_state = newValue
    },
    SET_DRUGAGE_STATE(state, newValue) {
        state.drugagerange_state = newValue
    },

    SET_UNITS(state, newValue) {
        state.units = newValue
    },
    SET_UNIT_STATE(state, newValue) {
        state.unit_state = newValue
    },

    SET_SUPPLIERS(state, newValue) {
        state.suppliers = newValue
    },

    SET_DISPENSING(state, newValue) {
        state.drug_dispense = newValue
    },
    SET_DISPENSE_STATE(state, newValue) {
        state.dispense_state = newValue
    },
    SET_ITEMS_STATE(state, newValue) {
        state.items_state = newValue
    },
    SET_STOCK_CART(state, newValue) {
        state.stock_cart = newValue
    },
    SET_TOTAL_CART(state, newValue) {
        state.total_cart = newValue
    },
    SET_DRUGS(state, newValue) {
        state.drugs = newValue
    },
    SET_SHORT_EXPIRIES(state, newValue) {
        state.short_expiries = newValue
    },
    SET_EXPIRED(state, newValue) {
        state.expired = newValue
    },
    SET_TO_RECONCILE(state, newValue) {
        state.reconcile = newValue
    },
    SET_TO_RECONCILIATION_REPORT(state, newValue) {
        state.reconciliation = newValue
    },
    SET_TO_RECONCILIATION(state, newValue) {
        state.reconciliationdetails = newValue
    },
   
};

export const actions = {
    removeDrug({ dispatch, commit }, data) {
        commit('SET_DISPENSE_STATE', true)
        axios.post('removeExp', data).then(() => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchExpired')
            let message = { 'msg': "Item removed successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            let message = { 'msg': 'Error removing item' }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchSale({ commit },id) {
        axios.get(`sale/${id}`).then(res => {
            commit('SET_SALE', res.data)
        })
    },
       fetchIncompleteDosage({ commit }) {
        axios.get('incomplete_dosage').then(res => {
            commit('SET_INCOMPLETE_DOSAGE', res.data)
        })
    },
       fetchDrugageRange({ commit }) {
        axios.get('get_drugage').then(res => {
            commit('SET_DRUGAGE', res.data)
        })
    },
    
    fetchReconcileReport({ commit },id) {
        axios.get(`reconcile/${id}`).then(res => {
            commit('SET_TO_RECONCILIATION', res.data)
        })
    },
    fetchToReconciliationReports({ commit }) {
        axios.get(`reconcilereports`).then(res => {
            commit('SET_TO_RECONCILIATION_REPORT', res.data)
        })
    },
    addDrugageRange({ dispatch,commit }, payload) {
        commit('SET_DRUGAGE_STATE', true)
        axios.post('drug_age', payload).then(() => {
            commit('SET_DRUGAGE_STATE', true)
            dispatch('fetchDrugageRange')
            let message = { 'msg': "Drug prescription added successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            let message = { 'msg': 'Error in recording Drug age_range, confirm that age-range is unique' }
            dispatch('notification/error', message, { root: true })
        })
    },
    editDrugageRange({ dispatch,commit }, payload) {
        commit('SET_DRUGAGE_STATE', true)
        axios.put(`editdrug_age/${payload.id}`, payload).then(() => {
            commit('SET_DRUGAGE_STATE', true)
            dispatch('fetchDrugageRange')
            let message = { 'msg': "Drug prescription updated successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            let message = { 'msg': 'Error in updating Drugage prescription' }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteDrugageRange({ dispatch,commit }, payload) {
        commit('SET_DRUGAGE_STATE', true)
        axios.delete(`delete_drugage/${payload.id}`).then(() => {
            commit('SET_DRUGAGE_STATE', true)
            dispatch('fetchDrugageRange')
            let message = { 'msg': "Drug prescription deleted successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            let message = { 'msg': 'Error in deleting Drugage prescription' }
            dispatch('notification/error', message, { root: true })
        })
    },
    saveReconcileStock({ dispatch, commit }) {
        commit('SET_DISPENSE_STATE', true)
        axios.post('SaveReconcilestock').then(() => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchToReconcile')
            let message = { 'msg': "Stock Reconciled successfully" }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            let message = { 'msg': 'Error Reconciling Stock' }
            dispatch('notification/error', message, { root: true })
        })
    },
    reconcileStock({ dispatch, commit }, data) {
        commit('SET_DISPENSE_STATE', true)
        axios.post('addstockquantity', data).then(() => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchToReconcile')
            let message = { 'msg': "Item added" }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            let message = { 'msg': 'Error adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchToReconcile({ commit }) {
        commit('SET_DISPENSE_STATE', true)
        axios.get('reconcilestock').then(d_res => {
            commit('SET_TO_RECONCILE', d_res.data)
            commit('SET_DISPENSE_STATE', false)
        })
    },
    fetchShortExpiries({ commit }) {
        commit('SET_DISPENSE_STATE', true)
        axios.get('short_expiry').then(d_res => {
            commit('SET_SHORT_EXPIRIES', d_res.data)
            commit('SET_DISPENSE_STATE', false)
        })
    },
    fetchStockOut({ commit }) {
        commit('SET_DISPENSE_STATE', true)
        axios.get('stockout').then(d_res => {
            commit('SET_STOCK_OUT', d_res.data)
            commit('SET_DISPENSE_STATE', false)
        })
    },
    fetchExpired({ commit }) {
        commit('SET_DISPENSE_STATE', true)
        axios.get('expired_items').then(d_res => {
            commit('SET_EXPIRED', d_res.data)
            commit('SET_DISPENSE_STATE', false)
        })
    },
    fetchDrugs({ commit }) {
        commit('SET_DISPENSE_STATE', true)
        axios.get('getdrugs').then(d_res => {
            commit('SET_DRUGS', d_res.data)
            commit('SET_DISPENSE_STATE', false)
        })
    },
    fetchPharmacyItems({ commit }) {
        axios.get('pharmacyitems').then(pi_res => {
            commit('SET_PHARMACY_ITEMS', pi_res.data)
        })
    },

    fetchItemCategories({ commit }) {
        axios.get('itemcategory').then(ic_res => {
            commit('SET_ITEM_CATEGORIES', ic_res.data)
        })
    },

    addCategory({ commit,dispatch },payload) {
        commit('SET_CATEGORY_STATE', true);
        axios.post('itemcategory',payload).then(() => {
            dispatch('fetchItemCategories');
            let message = { 'msg': "Category added successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_CATEGORY_STATE', false); 
        }).catch(() => {
            commit('SET_CATEGORY_STATE', false)
            let message = { 'msg': "Error Adding Category" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Category
    editCategory({ commit,dispatch },payload) {
        commit('SET_CATEGORY_STATE', true);
        axios.put(`itemcategory/${payload.id}`, payload).then(() => {
            dispatch('fetchItemCategories');
            let message = { 'msg': "Category updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_CATEGORY_STATE', false); 
        }).catch(() => {
            commit('SET_CATEGORY_STATE', false)
            let message = { 'msg': "Error updating Category" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete Category
    deleteCategory({ commit,dispatch },payload) {
        // console.log(payload);
        commit('SET_CATEGORY_STATE', true);
        axios.delete(`itemcategory/${payload.id}`).then(() => {
            dispatch('fetchItemCategories');
            let message = { 'msg': "Category deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_CATEGORY_STATE', false); 
        }).catch(() => {
            commit('SET_CATEGORY_STATE', false)
            let message = { 'msg': "Error deleting Category" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchUnits({ commit }) {
        axios.get('units').then(u_res => {
            commit('SET_UNITS', u_res.data)
        })
    },
    addUnit({ commit,dispatch },payload) {
        commit('SET_UNIT_STATE', true);
        axios.post('units',payload).then(() => {
            dispatch('fetchUnits');
            let message = { 'msg': "Unit added successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_UNIT_STATE', false); 
        }).catch(() => {
            commit('SET_UNIT_STATE', false)
            let message = { 'msg': "Error Adding Unit" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Unit
    editUnit({ commit,dispatch },payload) {
        commit('SET_UNIT_STATE', true);
        axios.put(`units/${payload.id}`, payload).then(() => {
            dispatch('fetchUnits');
            let message = { 'msg': "Unit updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_UNIT_STATE', false); 
        }).catch(() => {
            commit('SET_UNIT_STATE', false)
            let message = { 'msg': "Error updating Unit" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete Unit
    deleteUnit({ commit,dispatch },payload) {
        // console.log(payload);
        commit('SET_UNIT_STATE', true);
        axios.delete(`units/${payload.id}`).then(() => {
            dispatch('fetchUnits');
            let message = { 'msg': "Unit deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_UNIT_STATE', false); 
        }).catch(() => {
            commit('SET_UNIT_STATE', false)
            let message = { 'msg': "Error deleting Unit" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchCart({ commit }) {
        axios.get('stocks').then(cart => {
            commit('SET_STOCK_CART', cart.data)
            commit('SET_SUPPLIER_SHOW_STATUS', cart.data.data.length)
        })
    },
    fetchTotCart({ commit }) {
        axios.get('total_cart').then(total => {
            commit('SET_TOTAL_CART', total.data)
        })
    },
    saveItem({ dispatch, commit }, data) {
        commit('SET_ITEMS_STATE', true)
        axios.post('pharmacyitems', data).then(response => {
            commit('SET_ITEMS_STATE', false)
            dispatch('fetchPharmacyItems')
            if (response.status==200){
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            let message = { 'msg': data.name+' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },
    updateItem({ dispatch }, editData) {
        axios.put(`pharmacyitems/${editData.id}`, editData).then(() => {
            dispatch('fetchPharmacyItems')
        })
    },
    deleteItem({ dispatch }, deleteData) {
        axios.delete(`pharmacyitems/${deleteData.id}`).then(() => {
            dispatch('fetchPharmacyItems')
        })
    },

    addToCart({ dispatch, commit }, data) {
        commit('SET_DISPENSE_STATE', true)
        axios.post('stocks', data).then(response => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Item added successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to add item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': "Failed to add item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editCart({ dispatch, commit }, data) {
        commit('SET_DISPENSE_STATE', true)
        axios.put(`stocks/${data.id}`, data).then(response => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Item edited successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to edit item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': "Failed to edit item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editSup({ dispatch, commit }, data) {
        commit('SET_DISPENSE_STATE', true)
        axios.post(`edit_supplier`, data).then(response => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Supplier edited successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to edit Supplier" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': "Failed to edit Supplier" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteCart({ dispatch, commit }, data) {
        commit('SET_DISPENSE_STATE', true)
        axios.delete(`stocks/${data.id}`).then(response => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Item deleted successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to delete item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': data.name+' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    savePurch({ dispatch, commit }, data) {
        commit('SET_DISPENSE_STATE', true)
        axios.post(`savestock`, data).then(response => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Purchase Recorded successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to record Purchase" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': "Failed to record Purchase" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchSuppliers({ commit }) {
        axios.get('suppliers').then(sup_res => {
            commit('SET_SUPPLIERS', sup_res.data)
        })
    },

    saveSupplier({ dispatch }, data) {
        axios.post('suppliers', data).then(() => {
            dispatch('fetchSuppliers')
        })
    },

    updateSupplier({ dispatch }, editData) {
        axios.put(`suppliers/${editData.id}`, editData).then(() => {
            dispatch('fetchSuppliers')
        })
    },
    deleteSupplier({ dispatch }, deleteData) {
        axios.delete(`suppliers/${deleteData.id}`).then(() => {
            dispatch('fetchSuppliers')
        })
    },
    fetchDispensingDrug({ dispatch, commit }) {
        axios.get('prescriptions').then(dispense => {
            commit('SET_DISPENSING', dispense.data)
            dispatch('fetchSuppliers')
        })
    },
    UpdatePrescription({ dispatch, commit }, payload) {
        commit('SET_DISPENSE_STATE', true)
        axios.put(`prescriptions/${payload.id}`, payload).then(response => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('payments/fetchPatientPayments', null, {root:true})
            
            if (response.status==200){
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }
            dispatch('fetchDispensingDrug')
        }).catch(()=>{
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': 'Prescription update failed' }
            dispatch('notification/error', message, { root: true })
        })
    },
    RemovePrescription({ dispatch, commit }, payload) {
        commit('SET_DISPENSE_STATE', true)
        axios.delete(`prescriptions/${payload.id}`).then(() => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchDispensingDrug')
            dispatch('fetchIncompleteDosage')
            dispatch('payments/fetchPatientPayments', null, {root:true})
            let message = { 'msg': 'Prescription removed successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': 'Prescription removing failed' }
            dispatch('notification/error', message, { root: true })
        })
    },
    DispenseOneDrug({ dispatch, commit }, payload) {
        commit('SET_DISPENSE_STATE', true)
        axios.post('dispense_one', payload).then(response => {
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchDispensingDrug')
            dispatch('reports/fetchIncompleteDosageReport', null, {root:true})
            if (response.status == 200) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': 'Drug dispensing failed.' }
            dispatch('notification/error', message, { root: true })
        })
    },
    DispenseAllDrug({ dispatch, commit }, payload) {
        commit('SET_DISPENSE_STATE', true)
        axios.post('dispense', payload).then(response => {
            dispatch('reports/fetchIncompleteDosageReport', null, {root:true})
            commit('SET_DISPENSE_STATE', false)
            dispatch('fetchDispensingDrug')
            if (response.status == 200) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_DISPENSE_STATE', false)
            let message = { 'msg': 'Drug dispensing failed. Confirm if stock is enough.' }
            dispatch('notification/error', message, { root: true })
        })
    },
};